// extracted by mini-css-extract-plugin
export default {"home":"index_home__4B2fA","content":"index_content__d5UI1","top":"index_top__zXrYk","table":"index_table__sDQKB"};